var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-option-group',{style:(_vm.themeStyle),attrs:{"color":_vm.color,"inline":_vm.inline,"left-label":_vm.left,"options":_vm.options,"type":_vm.type,"value":_vm.value,"data-test-id":"fib-option-group"},on:{"input":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }